import {
  isCompletedPickup,
  isFuturePickup,
  isMissedPickup,
  isNewPickup,
  isNotCompletedPickup,
  isUnAcknowledgedPickup,
} from "../filterUtils";
import {
  MissedPickupMarker,
  DailyPickupMarker,
  FutureMarker,
  UnacknowledgedMarker,
  VoidedMarker,
  UnassignedPickupsMarker,
  CompletedMarker,
  NotCompletedMarker,
  NewPickUpIcon,
} from "../../../../mapComponents/Markers";
import { PICKUP_STATUS } from "../constants";

export const getPickupStatus = (pickup, terminalOffset) => {
  if (pickup.isVoided) {
    return PICKUP_STATUS.voided;
  }

  if (isFuturePickup(pickup.pickupDate, terminalOffset)) {
    return PICKUP_STATUS.future;
  }
  
  if (isCompletedPickup({pickup, terminalOffset})) {
    return PICKUP_STATUS.completed;
  }

  if (isMissedPickup({pickup})) {
    return PICKUP_STATUS.missed;
  }

  if (isUnAcknowledgedPickup({pickup, terminalOffset})) {
    return PICKUP_STATUS.unacknowledged;
  }

  if (isNotCompletedPickup({pickup, terminalOffset})) {
    return PICKUP_STATUS.notCompleted;
  }

  if (isNewPickup(pickup, terminalOffset)) {
    return PICKUP_STATUS.newPickup;
  }

  if (pickup.isDailyPickup) {
    return PICKUP_STATUS.dailyPickup;
  }

  return PICKUP_STATUS.unassigned;
};

export const getPickupStatusTypeIcon = (params) => {
  const {
    theme,
    backgroundColor,
    borderColor,
    size = 16,
    status,
  } = params;
  const primaryColor = theme.palette.primary.main;
  switch (status) {
    case PICKUP_STATUS.newPickup:
      return {
        type: status,
        marker: (
          <NewPickUpIcon
            backgroundColor={backgroundColor || theme.warningColor}
            borderColor={borderColor || theme.white}
            size={size}
          />
        ),
      };
    case PICKUP_STATUS.completed:
      return {
        type: status,
        marker: (
          <CompletedMarker
            backgroundColor={backgroundColor || primaryColor}
            borderColor={borderColor || theme.white}
            size={size}
          />
        ),
      };
    case PICKUP_STATUS.voided:
      return {
        type: status,
        marker: (
          <VoidedMarker
            size={size}
            backgroundColor={backgroundColor || theme.missedPickupIcon}
            borderColor={borderColor || theme.white}
          />
        ),
      };
    case PICKUP_STATUS.unacknowledged:
      return {
        type: status,
        marker: (
          <UnacknowledgedMarker
            size={size}
            backgroundColor={backgroundColor || theme.HeaderSelectedText}
            borderColor={borderColor || theme.white}
          />
        ),
      };
    case PICKUP_STATUS.future:
      return {
        type: status,
        marker: (
          <FutureMarker
            size={size}
            backgroundColor={backgroundColor || theme.warningColor}
            borderColor={borderColor || theme.white}
          />
        ),
      };
    case PICKUP_STATUS.notCompleted:
      return {
        type: status,
        marker: (
          <NotCompletedMarker
            size={size}
            backgroundColor={backgroundColor || theme.iconColor}
            borderColor={borderColor || theme.white}
          />
        ),
      };
    case PICKUP_STATUS.missed:
      return {
        type: status,
        marker: (
          <MissedPickupMarker
            size={size}
            backgroundColor={backgroundColor || theme.missedPickupIcon}
            borderColor={borderColor || theme.white}
          />
        ),
      };
    case PICKUP_STATUS.dailyPickup:
      return {
        type: status,
        marker: (
          <DailyPickupMarker
            size={size}
            backgroundColor={backgroundColor || theme.warningColor}
            borderColor={borderColor || theme.white}
          />
        ),
      };

    default:
      return {
        type: PICKUP_STATUS.unassigned,
        marker: (
          <UnassignedPickupsMarker
            backgroundColor={backgroundColor || theme.warningColor}
            borderColor={borderColor || theme.white}
            size={size}
          />
        ),
      };
  }
};
